import api from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  actions: {

    async findItemsByContratoId(_, payload) {
      const { id } = payload;
      if (!id) {
        throw new Error('O ID do contrato é obrigatório para a busca de itens.');
      }
      const { data } = await api.get(`contratocambionotafiscal/id/${id}`);
      return data;
    },
  },
};
